import { useState, useEffect } from "react";
import { Box, Typography, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { InboxDown } from "@mynaui/icons-react";
import RequestCard from "../components/RequestCard";
import { useZone } from "../../../shared/context/ZoneContext";
import { getDashboardDataByZone } from "../data/dashboardMockData";

export default function RequestsPage() {
  const { selectedZone } = useZone();
  const { requests: zoneRequests } = getDashboardDataByZone(selectedZone);
  const [searchQuery, setSearchQuery] = useState("");
  const [requests, setRequests] = useState(zoneRequests);
  const navigate = useNavigate();

  useEffect(() => {
    setRequests(zoneRequests);
  }, [selectedZone, zoneRequests]);

  const filteredRequests = requests.filter(
    (request) =>
      request.id.toLowerCase().includes(searchQuery.toLowerCase()) ||
      request.title.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const handleApprove = (requestId) => {
    console.log("Approved:", requestId);
    setRequests((prev) => prev.filter((item) => item.id !== requestId));
  };

  const handleReject = (requestId) => {
    console.log("Rejected:", requestId);
    setRequests((prev) => prev.filter((item) => item.id !== requestId));
  };

  const handleCardClick = (request) => {
    navigate(`/requests/${request.id}`);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 2, sm: 2.5, md: 3, lg: 4 },
        }}
      >
        <Box
          sx={{
            background: "#FFFFFF",
            border: "1px solid #E2E8F0",
            borderRadius: "12px",
            padding: "24px",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          {/* Header: Title + Search */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            {/* Left: Icon + Title */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <InboxDown size={24} />
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  lineHeight: "28px",
                  color: "#020618",
                }}
              >
                Requests
              </Typography>
            </Box>

            {/* Right: Search */}
            <TextField
              placeholder="Search"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              slotProps={{
                input: {},
              }}
              sx={{
                width: { xs: "100%", sm: "280px", md: "488px" },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  fontSize: "14px",
                  "& fieldset": {
                    borderColor: "#E2E8F0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#CBD5E1",
                  },
                },
              }}
            />
          </Box>

          {/* Cards Grid */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            {filteredRequests.map((request, index) => (
              <Box
                key={`${request.id}-${index}`}
                sx={{
                  flex: {
                    xs: "1 1 100%",
                    md: "1 1 calc(50% - 10px)",
                  },
                  maxWidth: {
                    xs: "100%",
                    md: "calc(50% - 10px)",
                  },
                  cursor: "pointer",
                }}
                onClick={() => handleCardClick(request)}
              >
                <RequestCard
                  request={request}
                  onApprove={handleApprove}
                  onReject={handleReject}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
